import React, { FC, useEffect } from 'react';

import Modal from '~components/atoms/Modal';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch } from '~redux/hooks';

import GoldTransactionDetails from '../GoldTransactionDetails';

type GoldTransactionDetailsModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const GoldTransactionDetailsModal: FC<GoldTransactionDetailsModalProps> = ({
    isOpen,
    onClose,
}) => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isOpen) {
            dispatch(combinedActions.goldClearSellOrBuyGoldParams());
        }
    }, [isOpen]);

    return (
        <Modal
            testId='transaction-product-details-summary-modal-close'
            isOpen={isOpen}
            onClose={onClose}
            title='Transaction Details'
        >
            <GoldTransactionDetails />
        </Modal>
    );
};

export default GoldTransactionDetailsModal;
